// Home / End move to the start / end of the textblock; Mod+Home / Mod+End to
// the start / end of the document.
//
// On macOS Home / End scroll the page and leave the caret. Here they mean the
// same as Ctrl+A / Ctrl+E (line start / end); with Shift they extend the
// selection. The edges of the block (paragraph, heading, list item), not of the
// wrapped visual line. Nothing happens on a non-text block (a selected divider).
//
// Ctrl+Home / Ctrl+End (Cmd on macOS) are done here too, as a transaction,
// instead of being left to the browser. The browser moves the DOM caret and
// ProseMirror reads it later (on selectionchange); a view update in between
// (a live editing update arriving from the server) wrote the old selection back
// into the DOM, and the caret stayed where it was.

import { Extension } from "@tiptap/core";
import { Selection, TextSelection } from "@tiptap/pm/state";

export const HomeEnd = Extension.create({
  name: "trameriaHomeEnd",

  addKeyboardShortcuts() {
    const move = (edge: "start" | "end", extend: boolean) => () => {
      const { state, view } = this.editor;
      const { selection } = state;
      const $head = selection.$head;
      if (!$head.parent.isTextblock) return false;
      const pos = edge === "start" ? $head.start() : $head.end();
      const anchor = extend ? selection.anchor : pos;
      view.dispatch(
        state.tr
          .setSelection(TextSelection.create(state.doc, anchor, pos))
          .scrollIntoView(),
      );
      return true;
    };
    const toDocEdge = (edge: "start" | "end", extend: boolean) => () => {
      const { state, view } = this.editor;
      const target =
        edge === "start"
          ? Selection.atStart(state.doc)
          : Selection.atEnd(state.doc);
      const next =
        extend && target instanceof TextSelection
          ? TextSelection.create(state.doc, state.selection.anchor, target.head)
          : target;
      view.dispatch(state.tr.setSelection(next).scrollIntoView());
      return true;
    };
    return {
      Home: move("start", false),
      End: move("end", false),
      "Shift-Home": move("start", true),
      "Shift-End": move("end", true),
      "Mod-Home": toDocEdge("start", false),
      "Mod-End": toDocEdge("end", false),
      "Shift-Mod-Home": toDocEdge("start", true),
      "Shift-Mod-End": toDocEdge("end", true),
    };
  },
});
